import { Component, Entity, registerComponent } from "aframe";
import { RTCClient } from "../../rtc/client";
import { Guid } from "../../rtc/guid";


/*

"rtc" component : establishes the connection with the RTC server

*/

export interface RtcComponent extends Component
{
	data : { id : Guid };
}
export interface RtcComponentEntity extends Entity
{
	rtc : RtcComponent;
}




interface RtcConnectorComponent extends Component
{
	connected : Promise<RTCClient>;
	data : {
		configurationUrl : string;
		connectionUrl : string;
	}
}

registerComponent("rtc", {
	schema : {
		configurationUrl : { type:"string", default:"/Rtc/Configuration"},
		connectionUrl : { type:"string", default:"/Rtc"}
	},
	init(this : RtcConnectorComponent)
	{
		const client = new RTCClient();

		client.addEventListener("connection-start", (event) => this.el.emit("rtc-connection-start"));
		client.addEventListener("connection-progress", (event) => this.el.emit("rtc-connection-progress", (event as CustomEvent).detail));

		client.addEventListener("client-ready", (event) => this.el.emit("rtc-client-ready"), { once : true } );
		this.connected = client.connect( this.data.configurationUrl, this.data.connectionUrl, 
			(request) => {
				const event = new CustomEvent("authenticate-request", { detail : request, bubbles : true });
				this.el.dispatchEvent(event);
				return event.detail;
			} );
			
		this.connected.then( 
			(client) => this.el.emit("rtc-connected", client),
			(reason) => console.warn("RTC Failed to connect : ", reason) );
	}
});
